import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getSkeletonUtilityClass(slot) {
  return generateUtilityClass('MuiSkeleton', slot);
}
const skeletonClasses = generateUtilityClasses('MuiSkeleton', ['root', 'variantOverlay', 'variantCircular', 'variantRectangular', 'variantText', 'variantInline', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'body1', 'body2', 'body3']);
export default skeletonClasses;